import { render, staticRenderFns } from "./guideSetting.vue?vue&type=template&id=ba5d6ea4&scoped=true&"
import script from "./guideSetting.vue?vue&type=script&lang=js&"
export * from "./guideSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5d6ea4",
  null
  
)

export default component.exports